import styled from '@emotion/styled';
import { CreateAgentButton } from './CreateAgentButton';
import { InsightsButton } from './InsightsButton';

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

const Buttons = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
    margin-left: auto;
`;

export const Header = () => {
    return (
        <Container>
            <Buttons>
                <InsightsButton />
                <CreateAgentButton />
            </Buttons>
        </Container>
    );
};
